<template>
  <va-modal
    v-model="state.isOpen"
    hide-default-actions
    :title="$t('organizations.createModal.title')"
  >
    <slot>
      <div class="create-organization-modal">
        <va-input
          v-model="state.organizationName"
          label="Organization Name"
          placeholder="Enter organization name"
        />
        <div class="switch-container">
          <va-switch
            v-model="state.isPartner"
            :label="$t('organizations.isPartner')"
          />
        </div>
        <p class="partner-hint">{{ $t("organizations.partnerHint") }}</p>
      </div>
    </slot>

    <template #footer>
      <va-button flat outline class="mr-1" @click="emit('cancel')">
        {{ $t("buttons.cancel") }}
      </va-button>
      <va-button class="ml-1" color="primary" @click="createOrganization">
        {{ $t("buttons.submit") }}
      </va-button>
    </template>
  </va-modal>
</template>

<script setup>
import { computed, reactive } from "vue";

const props = defineProps({
  isOpen: {
    type: Boolean,
    default: false
  }
});

const state = reactive({
  isOpen: computed(() => props.isOpen),
  organizationName: "",
  isPartner: false
});

const emit = defineEmits(["cancel", "create"]);

/**
 * Emits the new organization's name and whether it represents a Lumivero
 * partner (IdentityHub's `isPartner`, which sends its invitations to the
 * Partner Portal), then resets the form.
 */
const createOrganization = () => {
  const name = state.organizationName.trim();
  if (name) {
    emit("create", { name, isPartner: state.isPartner });
    state.organizationName = "";
    state.isPartner = false;
  }
};
</script>

<style scoped>
.create-organization-modal {
  min-width: min(400px, calc(100vw - 4rem));
}

.va-input {
  margin-bottom: 1rem;
}

.switch-container {
  display: flex;
  align-items: center;
  margin-top: 1rem;
  margin-bottom: 1rem;
}

.partner-hint {
  max-width: 400px;
  font-size: 0.85rem;
  color: var(--va-secondary);
}

.ml-2 {
  margin-left: 0.5rem;
}
.checkbox {
  margin-right: 0.5rem;
  align-items: center;
  background-color: var(--va-checkbox-square-background-color);
  border: var(--va-checkbox-square-border);
  border-radius: var(--va-checkbox-square-border-radius);
  display: flex;
  height: var(--va-checkbox-square-height);
  justify-content: center;
  min-width: var(--va-checkbox-square-min-width);
  position: var(--va-checkbox-square-position);
  width: var(--va-checkbox-square-width);
}
</style>
